import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from './../PageLayout/CheckBox';
import BlueDropDown from './../PageLayout/DropDowns/BlueDropDown';
import { supportedCountries } from './purchaseReducer';
export default function () {
    function onChange1(purchase, sub, g, e) {
        this.setPaymentInfo(e, 'name');
    }
    function onItemClick2(purchase, sub, g, country) {
        this.selectCountry(country);
    }
    function onChange3(purchase, sub, g, e) {
        this.setPaymentInfo(e, 'zipCode');
    }
    function onChange4(purchase, sub, g, e) {
        this.setPaymentInfo(e, 'ccNum');
    }
    function onChange5(purchase, sub, g, e) {
        this.setPaymentInfo(e, 'expMonth');
    }
    function onChange6(purchase, sub, g, e) {
        this.setPaymentInfo(e, 'expYear');
    }
    function onChange7(purchase, sub, g, e) {
        this.setPaymentInfo(e, 'cvv');
    }
    function scopePurchaseSubG8() {
        var purchase = this.props.purchase;
        var sub = purchase.selectedSubscription;
        var g = purchase.selectedSubscriptionGroupRef;
        return React.createElement('div', { 'className': 'paper' }, React.createElement('div', { 'className': 'logo' }), React.createElement('div', { 'className': 'pm pm--payment' }, purchase.isModal ? React.createElement('button', {
            'className': 'pm-close',
            'key': '505'
        }) : null, React.createElement('div', { 'className': 'pm-header' }, React.createElement('span', { 'className': 'pm-header__logo' }), React.createElement('h1', { 'className': 'pm-header__title' }, g.title), React.createElement('div', { 'className': 'pm-header__price' }, React.createElement('span', { 'className': 'pm-header__price-total' }, 'Total'), React.createElement('span', { 'className': 'pm-header__price-sum' }, '$', sub.price.toFixed(2)))), React.createElement('div', { 'className': 'payment' }, false ? React.createElement('div', {
            'className': 'payment-invoice',
            'key': '986'
        }, React.createElement('button', { 'className': 'ui-button5 ui-button5--blue ui-button5--bold ui-button5--small ui-button5--round ui-button5--with-icon' }, React.createElement('span', { 'className': 'ui-button5-icon ui-button5-icon--list' }), '\r\n          VIEW ORDER INVOICE\r\n        ')) : null, React.createElement('ul', { 'className': 'payment-user' }, React.createElement('li', { 'className': 'payment-user__input' }, React.createElement('input', {
            'type': 'name',
            'placeholder': 'Name on card',
            'id': 'name',
            'className': 'generic-popup-textbox',
            'value': this.state.paymentInfo.name,
            'onChange': onChange1.bind(this, purchase, sub, g)
        })), React.createElement('li', { 'className': 'payment-user__input payment-user__input--half payment-user__input--left' }, React.createElement(BlueDropDown, {
            'items': supportedCountries,
            'style': {
                textAlign: 'left',
                width: '100%'
            },
            'itemKey': this.countryKey,
            'itemValue': this.countryKey,
            'onItemClick': onItemClick2.bind(this, purchase, sub, g),
            'selectedItem': this.state.paymentInfo.country
        })), React.createElement('li', { 'className': 'payment-user__input payment-user__input--half payment-user__input--right' }, React.createElement('input', {
            'type': 'text',
            'placeholder': 'Zip Code',
            'id': 'zip',
            'className': 'generic-popup-textbox',
            'value': this.state.paymentInfo.zipCode,
            'onChange': onChange3.bind(this, purchase, sub, g)
        }))), React.createElement('ul', { 'className': 'payment-methods' }, purchase.isPayPalSupported ? React.createElement('li', {
            'className': 'method method--paypal',
            'key': '2610'
        }, React.createElement('div', { 'className': 'method-selection' }, React.createElement('div', { 'className': 'method-checkbox' }, React.createElement('div', { 'className': 'radio-ring' }, React.createElement('div', { 'className': 'radio-check' }))), React.createElement('div', { 'className': 'method-info' }, React.createElement('span', { 'className': 'method-info__logo' }), React.createElement('p', { 'className': 'method-info__text' }, 'Pay quickly and securely with your PayPal Account')))) : null, purchase.isCreditCardSupported ? React.createElement('li', {
            'className': 'method method--card method--selected',
            'key': '3144'
        }, React.createElement('div', { 'className': 'method-selection' }, React.createElement('div', { 'className': 'method-checkbox' }, React.createElement('div', { 'className': 'radio-ring' }, React.createElement('div', { 'className': 'radio-check' }))), React.createElement('div', { 'className': 'method-info' }, React.createElement('span', { 'className': 'method-info__logo' }), React.createElement('p', { 'className': 'method-info__text' }, 'Pay securely with Visa, Mastercard and American Express'))), React.createElement('div', { 'className': 'method-inputs' }, React.createElement('div', { 'className': 'method-input' }, React.createElement('input', {
            'className': 'generic-popup-textbox',
            'id': 'cc_num',
            'placeholder': 'Card Number',
            'value': this.state.paymentInfo.ccNum,
            'onChange': onChange4.bind(this, purchase, sub, g)
        })), React.createElement('div', { 'className': 'method-input' }, React.createElement('div', { 'className': 'method-input__date' }, React.createElement('input', {
            'className': 'generic-popup-textbox',
            'id': 'exp_month',
            'size': '2',
            'placeholder': 'MM',
            'maxLength': '2',
            'value': this.state.paymentInfo.expMonth,
            'onChange': onChange5.bind(this, purchase, sub, g)
        }), React.createElement('input', {
            'className': 'generic-popup-textbox',
            'id': 'exp_year',
            'size': '4',
            'placeholder': 'YYYY',
            'maxLength': '4',
            'value': this.state.paymentInfo.expYear,
            'onChange': onChange6.bind(this, purchase, sub, g)
        }), React.createElement('p', { 'className': 'method-input__description' }, 'Expiration Date')), React.createElement('div', { 'className': 'method-input__cvv' }, React.createElement('input', {
            'className': 'generic-popup-textbox',
            'id': 'cvv',
            'size': '4',
            'placeholder': 'CVV',
            'maxLength': '4',
            'value': this.state.paymentInfo.cvv,
            'onChange': onChange7.bind(this, purchase, sub, g)
        }), React.createElement('p', { 'className': 'method-input__description' }, 'Security Code'))))) : null, purchase.isBitCoinSupported ? React.createElement('li', {
            'className': 'method method--bitcoin method--selected',
            'key': '5028'
        }, React.createElement('div', { 'className': 'method-selection' }, React.createElement('div', { 'className': 'method-checkbox' }, React.createElement('div', { 'className': 'radio-ring' }, React.createElement('div', { 'className': 'radio-check' }))), React.createElement('div', { 'className': 'method-info' }, React.createElement('span', { 'className': 'method-info__logo' }), React.createElement('p', { 'className': 'method-info__text' }, 'Pay with digital gold annoymously that is most secure.'))), React.createElement('div', { 'className': 'method-qr' }, React.createElement('div', {
            'className': 'method-qr__code',
            'style': { backgroundImage: 'url(images/pricing/qr-example.png)' }
        }), React.createElement('div', { 'className': 'method-qr__body' }, React.createElement('div', { 'className': 'btc' }, React.createElement('div', { 'className': 'btc-price' }, React.createElement('span', { 'className': 'btc-price__total' }, 'TOTAL'), React.createElement('span', { 'className': 'btc-price__sum' }, '5.0644186047 BTC')), React.createElement('div', { 'className': 'btc-address' }, React.createElement('span', { 'className': 'btc-address__text' }, 'Payment Address'), React.createElement('span', { 'className': 'btc-address__hash' }, '1BfyiB5N8gsoSe5qwna4A5WnDienNTxFdQ')))))) : null)), React.createElement('div', { 'className': 'pm-footer text-center' }, React.createElement('button', {
            'className': 'ui-button5 ui-button5--green',
            'onClick': this.submitPayment
        }, React.createElement('span', { 'className': 'ui-button-continue' }, 'Submit Payment')))));
    }
    return scopePurchaseSubG8.apply(this, []);
}